import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BaseModalComponent, ModalHeight, ModalSize } from "../base-modal/base-modal.component";
import { ButtonModule } from "primeng/button";

/**
 * Standard riverbed "confirmation" shell over app-base-modal: pass a title
 * and project body content, get the parchment/Montserrat-Alternates
 * 25px/600-weight title plus a full-opacity confirm pill and a 50%-opacity
 * cancel pill for free.
 */
@Component({
  selector: "app-confirmation-modal",
  templateUrl: "./confirmation-modal.component.html",
  styleUrls: ["./confirmation-modal.component.scss"],
  standalone: true,
  imports: [CommonModule, BaseModalComponent, ButtonModule],
})
export class ConfirmationModalComponent {
  @Input() title = "";
  /** Responsive width preset forwarded to app-base-modal. */
  @Input() size: ModalSize = "standard";
  /** Raw CSS width forwarded to app-base-modal; overrides `size` when set. */
  @Input() width?: string;
  /** Height preset forwarded to app-base-modal. Defaults to content-sized. */
  @Input() height: ModalHeight = "auto";
  @Input() cancelText = "Cancel";
  @Input() confirmText = "Confirm";
  /**
   * Hide the cancel pill to use this shell for a single-action notice — the confirm pill
   * then stretches to full width on its own. Defaults to true so every existing caller
   * keeps both buttons.
   */
  @Input() showCancel = true;

  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();
}
